(() => {
  const componentSelector = '[data-article-toc]';

  const createHeadingId = (heading, index, usedIds) => {
    if (heading.id) return heading.id;

    const slug = heading.textContent
      .trim()
      .toLowerCase()
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
    const baseId = `article-section-${slug || index + 1}`;
    let headingId = baseId;
    let suffix = 2;

    while (usedIds.has(headingId)) {
      headingId = `${baseId}-${suffix}`;
      suffix += 1;
    }

    heading.id = headingId;
    usedIds.add(headingId);
    return headingId;
  };

  const initializeTableOfContents = (component) => {
    if (component.dataset.articleTocInitialized === 'true') return;

    const article = component.closest('.article');
    const articleContent = article?.querySelector('.article__content');
    const list = component.querySelector('[data-article-toc-list]');
    const details = component.querySelector('details');

    if (!articleContent || !list) return;

    if (details && window.matchMedia('(max-width: 1279.98px)').matches) {
      details.removeAttribute('open');
      details.setAttribute('aria-expanded', 'false');
    }

    const headings = Array.from(articleContent.querySelectorAll('h2, h3')).filter(
      (heading) => heading.textContent.trim() !== '',
    );

    if (headings.length === 0) {
      component.remove();
      return;
    }

    const usedIds = new Set(Array.from(document.querySelectorAll('[id]'), (element) => element.id));

    headings.forEach((heading, index) => {
      const headingId = createHeadingId(heading, index, usedIds);
      const item = document.createElement('li');
      const link = document.createElement('a');

      item.className = `article-table-of-contents__item article-table-of-contents__item--${heading.tagName.toLowerCase()}`;
      link.className = 'article-table-of-contents__link';
      link.href = `#${headingId}`;
      link.textContent = heading.textContent.trim();

      heading.classList.add('article-table-of-contents__target');
      item.appendChild(link);
      list.appendChild(item);
    });

    component.dataset.articleTocInitialized = 'true';
    component.hidden = false;
  };

  const initializeAllTablesOfContents = (scope = document) => {
    scope.querySelectorAll(componentSelector).forEach(initializeTableOfContents);
  };

  if (!window.GDTArticleTableOfContents) {
    window.GDTArticleTableOfContents = { initialize: initializeAllTablesOfContents };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAllTablesOfContents());
    } else {
      initializeAllTablesOfContents();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAllTablesOfContents(event.target));
  } else {
    window.GDTArticleTableOfContents.initialize();
  }
})();
